import { E_RISK_TYPE, IActiveCountryMap, VIEW } from 'interfaces';
import React from 'react';
import GQMapProvider from 'components/GQMap/GQMapProvider';
import useInitCountryDim from 'hooks/useInitCountryDim';
import { MultilateralRiskPage } from 'components/Pickers/MultilateralRiskPicker';
import { inject } from 'mobx-react';
import { IMobxRootState } from 'RootStore';
import { SortByDeltaLegend } from './SortByDeltaLegend';
import { first, tail } from 'lodash/fp';

export const SortByContingentDeltaPage = React.memo(() => {
    return (
        <MultilateralRiskPage>
            <SortByContingentDelta />
        </MultilateralRiskPage>
    );
});

type Props = {
    selectedCountries?: number[];
    licencedCountries?: IActiveCountryMap;
    primaryCountry?: number;
};

export const SortByContingentDelta = inject(
    ({ countryStore }: IMobxRootState) => {
        return {
            primaryCountry: first(countryStore.currentCountryList),
            selectedCountries: tail(countryStore.currentCountryList),
            licencedCountries: countryStore.countries.licensedCountries,
        };
    }
)((props: Props) => {
    const ready = useInitCountryDim({
        riskType: E_RISK_TYPE.CONTINGENT,
        multiCountry: true,
        multiRisk: false,
    });

    if (!ready) return null;
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                position: 'relative',
            }}>
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                    <GQMapProvider view={VIEW.SORT_BY_CONTINGENT_DELTA} />
                </div>
                {props.primaryCountry && (
                    <SortByDeltaLegend
                        selectedCountries={props.selectedCountries}
                        licencedCountries={props.licencedCountries}
                    />
                )}
            </div>
        </div>
    );
});
